import { ArrayUtils } from "../../../utilities/arrays";
import { autoinject } from "aurelia-dependency-injection";

@autoinject
export class ActivityLoggerComposer {
    private vmWithModelSet: ViewModelPathWithModel[] = [];

    public register(vmWithModel: ViewModelPathWithModel) {
        const index = ArrayUtils.findIndex(this.vmWithModelSet, x => x == vmWithModel);
        if (index < 0) {
            this.vmWithModelSet.push(vmWithModel);
        }
    }

    public get(icon: string) {
        return this.vmWithModelSet.filter(x => x.icon == icon)[0];
    }

    public unregister(vmWithModel: ViewModelPathWithModel) {
        const index = ArrayUtils.findIndex(this.vmWithModelSet, x => x == vmWithModel);
        if (index >= 0) {
            this.vmWithModelSet.splice(index, 1);
        }
    }
}

export class ViewModelPathWithModel {
    icon: string;
    viewModel: string;
    modelInitiator: () => any;
}